import { combineReducers } from '@ngrx/store';
import * as fundChartAppReducers from './reducers';
import { savedItems } from 'Angular/features/components/saved-items/state/saved-items.reducer';
import { appStateSliceKey } from 'Angular/state/app-state/app-state.reducer';
import { calcInfo } from 'CalculationsApp/ts/state/calc-info.reducer';
import * as fundChartSharedReducers from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers';
import { fundChartPageUseCustomColors } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-options/show-custom-colors.reducer';
import { securitiesInfo } from 'SecuritiesApp/ts/state/securities-info/securities-info.reducer';
import { FUND_CHART_APP_STATE_SLICE_KEY, FUND_CHART_PAGE_DEFAULT_STATE, FUND_CHART_SYSTEM_DEFAULT_STATE, } from 'ChartApp/ts/features/fundamental-chart/constants';
import { createReducerWithAppState } from 'Angular/state/app-state/utils';
export const fundChart = combineReducers({
    ...fundChartAppReducers,
    ...fundChartSharedReducers,
});
const fundChartPage = combineReducers({
    ...fundChartAppReducers,
    ...fundChartSharedReducers,
    useCustomColors: fundChartPageUseCustomColors,
});
const initialUserState = {
    [FUND_CHART_APP_STATE_SLICE_KEY]: window.userProvidedAppState,
};
const sharedReducers = {
    appStateSliceKey,
    savedItems,
    calcInfo,
    securitiesInfo,
};
// The Fund Chart page and the security page Fund Chart tabs
export const rootReducer = createReducerWithAppState(combineReducers({ ...sharedReducers, [FUND_CHART_APP_STATE_SLICE_KEY]: fundChartPage }), { [FUND_CHART_APP_STATE_SLICE_KEY]: FUND_CHART_PAGE_DEFAULT_STATE }, initialUserState);
// Other apps that reuse the fund chart store (e.g. the chart editor) keep the system defaults
export const systemDefaultRootReducer = createReducerWithAppState(combineReducers({ ...sharedReducers, [FUND_CHART_APP_STATE_SLICE_KEY]: fundChart }), { [FUND_CHART_APP_STATE_SLICE_KEY]: FUND_CHART_SYSTEM_DEFAULT_STATE }, initialUserState);
